import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Megaphone, Send } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export const BroadcastDialog = ({ open, onOpenChange, onSent }) => {
  const [target, setTarget] = useState("riders");
  const [branches, setBranches] = useState([]);
  const [all, setAll] = useState([]);
  const [body, setBody] = useState("");
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.branches().then((r) => setAll((r || []).map((b) => b.branch).filter(Boolean))).catch(() => {}); else { setBody(""); setBranches([]); } }, [open]);
  useEffect(() => {
    if (!open) return;
    setCount(null);
    const t = setTimeout(() => api.corrBroadcast({ target, branches, dry_run: true }).then((r) => setCount(r.count)).catch(() => setCount(0)), 250);
    return () => clearTimeout(t);
  }, [open, target, branches]);
  const toggle = (b) => setBranches((p) => (p.includes(b) ? p.filter((x) => x !== b) : [...p, b]));
  const send = async () => {
    if (!body.trim()) { toast.warning("اكتب نص الرسالة"); return; }
    if (!window.confirm(`إرسال الرسالة إلى ${count} موظف؟`)) return;
    setBusy(true);
    try { const r = await api.corrBroadcast({ target, branches, body }); toast.success(`جارٍ إرسال الرسالة إلى ${r.count} موظف — تصل كل واحد في محادثته`); onOpenChange(false); onSent?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإرسال"); } finally { setBusy(false); }
  };
  const chip = (on) => `rounded-full border px-3 py-1 text-xs font-bold transition-colors ${on ? "border-emerald-600 bg-emerald-600 text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg p-0 overflow-hidden font-body" dir="rtl" data-testid="corr-broadcast-dialog">
        <DialogHeader className="bg-emerald-600 px-4 py-3 text-right text-white">
          <DialogTitle className="flex items-center gap-2 font-heading text-lg"><Megaphone className="h-5 w-5" /> رسالة جماعية</DialogTitle>
          <DialogDescription className="text-right text-xs text-emerald-50">تصل لكل موظف في محادثته الخاصة معك، ويرد عليك وحدك</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 px-4 pb-4">
          <div><p className="mb-1 text-xs font-semibold text-slate-500">إلى</p>
            <div className="flex gap-1.5">
              <button type="button" className={chip(target === "riders")} onClick={() => setTarget("riders")} data-testid="corr-bc-riders">المناديب فقط</button>
              <button type="button" className={chip(target === "all")} onClick={() => setTarget("all")} data-testid="corr-bc-all">كل الموظفين</button>
            </div></div>
          <div><p className="mb-1 text-xs font-semibold text-slate-500">الفروع <span className="font-normal text-slate-400">(بدون اختيار = كل الفروع)</span></p>
            <div className="flex flex-wrap gap-1.5">{all.map((b) => <button key={b} type="button" className={chip(branches.includes(b))} onClick={() => toggle(b)} data-testid={`corr-bc-branch-${b}`}>{b}</button>)}</div></div>
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={5} placeholder="نص الرسالة…" data-testid="corr-bc-body"
            className="w-full resize-none rounded-xl border border-slate-200 p-3 text-sm outline-none focus:ring-2 focus:ring-emerald-300" />
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-600" data-testid="corr-bc-count">المستلمون: {count === null ? <Loader2 className="inline h-4 w-4 animate-spin" /> : <b>{count}</b>}</span>
            <Button onClick={send} disabled={busy || !count} className="gap-1.5 bg-emerald-600 hover:bg-emerald-700" data-testid="corr-bc-send">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4 -scale-x-100" />} إرسال</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
